import styled from "styled-components";
import { styledByTheme } from "../../../../themes/architecture/styled-by-theme";

const VouchersGamesListTitleDefaultBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 1.5rem;
    padding: 10px 4px 10px 4px;
    width: 100%;

    border-bottom-width: 4px;
    border-bottom-style: solid;
    border-bottom-color: #0e0e0e;
`;

const VouchersGamesListTitleCasino777Box = styled(VouchersGamesListTitleDefaultBox)`
    border-top:1px solid transparent;
    padding-top:1.5rem;
`;

export const VouchersGamesListTitleBox = styledByTheme(VouchersGamesListTitleDefaultBox).forCasino777(VouchersGamesListTitleCasino777Box).apply();